import gql from 'graphql-tag';

export const GET_SCOREBOARD = gql`
    query Scoreboard(
        $slug: String!
    ) {
        scoreboard(slug: $slug) {
            _id
            names
            link
            points
            position
            tags
        }
    }
`;
